import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js";
import ServiceNav from "../components/ServiceNav";
import ServiceHero from "../components/ServiceHero";
import { FiCheckCircle, FiTrendingUp, FiSearch, FiMail } from "react-icons/fi";
import { ServiceCta } from "../components/CtaSystem";
import "./DigitalMarket.css";

const services = [
  {
    title: "Affiliate Marketing - Performance-Based Growth",
    description:
      "Leverage the power of affiliate marketing to drive sales and brand awareness. Our strategy focuses on partnerships, commission-based promotions, and high-converting traffic sources.",
  },
  {
    title: "SEO Optimization - Enhance Search Visibility",
    description:
      "Boost your brand’s online presence with advanced SEO techniques, including keyword research, on-page optimization, and technical improvements.",
  },
  {
    title: "Social Media Marketing (SMM) - Maximize Engagement",
    description:
      "Utilize targeted social media campaigns on platforms like Facebook, Instagram, and LinkedIn to enhance customer interaction and brand recognition.",
  },
  {
    title: "Pay-Per-Click (PPC) Advertising - Generate Instant Leads",
    description:
      "Launch data-driven PPC campaigns using Google Ads and Meta Ads to achieve high ROI and convert targeted leads into customers.",
  },
  {
    title: "Content Marketing - Drive Authority and Trust",
    description:
      "Create compelling blog posts, videos, and infographics to establish industry authority and engage potential customers effectively.",
  },
  {
    title: "Email Marketing - Automate Customer Outreach",
    description:
      "Develop personalized email campaigns that nurture leads, build loyalty, and drive consistent engagement with your audience.",
  },
  {
    title: "Who Can Benefit from Digital Marketing?",
    description:
      "Our digital marketing services cater to:\n- BFSI (Banking, Financial Services, Insurance)\n- E-commerce & Retail\n- Corporate Enterprises\n- Small Businesses & Startups\n- Influencers & Personal Brands.",
  },
];

const DigitalMarket = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const openPDF = () => {
    window.open("./Digital-Marketing.pdf");
  };

  const nextService = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  const prevService = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        nextService();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered]);

  return (
    <div className="digital-market-container">
      {/* Hero Section */}
      <ServiceHero
        kicker="SERVICE 07"
        title="Digital Marketing Services"
        description="Transform your digital presence with innovative marketing strategies tailored for BFSI and other industries."
        bgImage="/service7.png"
        onConnectClick={() => setIsPopupOpen(true)}
        onPdfClick={openPDF}
      />

      {/* About Digital Marketing */}
      <section className="about-dm-section">
        <div className="about-content">
          <div className="vector-image">
            <img src="./dm.png" alt="Digital Marketing Vector" />
          </div>

          <div className="about-text">
            <h2>What is Digital Marketing?</h2>
            <p>
              Digital marketing is essential for businesses aiming to grow in a competitive landscape. Our strategies include Affiliate Marketing, SEO, PPC, and more to ensure maximum reach and impact.
            </p>
            <ul>
              <li><FiCheckCircle className="check-icon" /> Affiliate Marketing & Performance-Based Growth</li>
              <li><FiCheckCircle className="check-icon" /> SEO & PPC for High-Quality Lead Generation</li>
              <li><FiCheckCircle className="check-icon" /> Social Media & Content Marketing for Brand Awareness</li>
              <li><FiCheckCircle className="check-icon" /> Email & Automation for Customer Retention</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Digital Marketing Services?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon"><FiTrendingUp /></span>
            <h3>Affiliate Marketing</h3>
            <p>Grow your business with performance-based partnerships.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiSearch /></span>
            <h3>SEO & PPC</h3>
            <p>Improve search rankings and generate leads efficiently.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiMail /></span>
            <h3>Email & Automation</h3>
            <p>Engage and retain customers with automated campaigns.</p>
          </div>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="dm-bottom-section">
        <h2>Leverage Digital Marketing for Success</h2>
        <div
          className="service-carousel"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="service-card">
            <h3>{services[currentIndex].title}</h3>
            <p>{services[currentIndex].description}</p>
            <div className="carousel-controls">
              <button onClick={prevService}>&#9665;</button>
              <button onClick={nextService}>&#9655;</button>
            </div>
          </div>
        </div>
      </section>

      {/* Service CTA */}
      <ServiceCta
        eyebrow="DIGITAL MARKETING"
        heading="Scale Your Brand Visibility & Drive High-Quality Enterprise Leads"
        primaryBtnText="Connect Now!"
        onPrimaryClick={() => setIsPopupOpen(true)}
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />

      {/* Service Navigation */}
      <ServiceNav currentPath="/digital-market" />

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default DigitalMarket;
